export function normalizeRoles(user) {
  const roles = (user?.roles || []).map(r => (r || '').toLowerCase());
  return roles;
}

export function isAdmin(user) {
  return normalizeRoles(user).includes('admin');
}

export function isPro(user) {
  return normalizeRoles(user).includes('paiduser');
}

export function isEnterpriseUser(user) {
  const roles = normalizeRoles(user);
  return roles.includes('enterpriseuser') || roles.includes('enterpriseadmin');
}

export function isTeamUser(user) {
  const roles = normalizeRoles(user);
  return roles.includes('teamuser') || roles.includes('teamadmin');
}

export function getUserType(user) {
  if (isAdmin(user)) return 'Admin';
  const roles = normalizeRoles(user);
  if (roles.includes('enterpriseadmin')) return 'EnterpriseAdmin';
  if (roles.includes('enterpriseuser')) return 'EnterpriseUser';
  if (roles.includes('teamadmin')) return 'TeamAdmin';
  if (roles.includes('teamuser')) return 'TeamUser';
  if (isPro(user)) return 'Pro';
  return 'Free';
}


